export default __webpack_public_path__ + "static/media/chevron-down.87451f40.svg";